import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

export const HeaderRight = ({ className, children }: HTMLAttributes<HTMLDivElement>) => {
    return <div className={classNames(className, 'ds-header-right')}>{children}</div>;
};
